import {useEffect} from 'react';
const constants = require('./constants');

const Login = props => {

    const getUcidParam = () => {
        var url = window.location;
        var baseEsignUrl = process.env.REACT_APP_ESIGN_URL.replace("https://", "").replace("http://", "");
        var ucidKey = url.toString().replace(baseEsignUrl, "").replace("https://", "").replace("http://", "").replaceAll("/", "");

        if(ucidKey && ucidKey.length > 0) {
          return "/?customerContextPath="+ucidKey;
        } else {
          return "";
        }
    }

    useEffect(() => {
        console.log("LOGIN...", constants.SERVER_URL+"/api/login")
        var url = window.location.toString();
        var command = "/api/login";

        if(url.includes("/api/signrequest?sid=")) {
          var baseEsignUrl = process.env.REACT_APP_ESIGN_URL.replace("https://", "").replace("http://", "");
          command = url.toString().replace(baseEsignUrl, "").replace("https://", "").replace("http://", "")
        } else {
          command = command +getUcidParam();
        }

        console.log ("Command: ", command);
        fetch(constants.SERVER_URL+command, {method:'get'})
        .then(resp => {
          if(resp.redirected) {
            console.log("REDIRECTED: ", resp)
            console.log(resp.url);
            window.location.href = ""+resp.url+"";
            sessionStorage.setItem("targetPage", constants.SERVER_CONTEXT_PATH+"/");
            console.log("Login loc, top loc: ",window.self, window.top)
            if(window.self !== window.top) {
              window.parent.postMessage("message", '*');
              window.top.location.reload();
            }
          }
        });
      },[]);
      return null;
}

export default (Login);
